export const TOKEN_SFL = 'SFL';
export const TOKEN_TRI = 'TRI';
